module.exports = __webpack_public_path__ + "img/fi-rr-globe.2304a2dc.svg";